import type { ReactNode } from 'react';

interface MoodSphereProps {
  label: string;
  onClick: () => void;
  art: ReactNode;
  bgTint: string;
  borderTint: string;
  hoverBorder: string;
  activeBg: string;
  labelColor: string;
}

export default function MoodSphere({
  label,
  onClick,
  art,
  bgTint,
  borderTint,
  hoverBorder,
  activeBg,
  labelColor,
}: MoodSphereProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`group flex flex-col items-center gap-3 cursor-pointer transition-all duration-300 hover:scale-105 active:scale-95`}
    >
      {/* Circular sphere with line-art */}
      <div
        className={`relative w-20 h-20 md:w-24 md:h-24 rounded-full border ${bgTint} ${borderTint} ${hoverBorder} ${activeBg} flex items-center justify-center transition-all duration-300 group-hover:shadow-md`}
      >
        <div className="w-10 h-10 md:w-12 md:h-12 text-foreground-500/70">
          {art}
        </div>
      </div>
      <span className={`text-sm font-medium ${labelColor} whitespace-nowrap transition-colors`}>
        {label}
      </span>
    </button>
  );
}